<template>
  <WhitePage :loading="loading">
    <title-bar>サブキャラクター作成</title-bar>
    <p>
      サブキャラクターを作成します。残り{{ max-current }}人登録できます。
    </p>
    <b-form>
      <b-form-group id="nickname" label="愛称">
        <b-form-input v-model="form.nickname" />
      </b-form-group>
      <b-form-group id="world" label="初期世界">
        <select-list :items="world"
          :fields="[
            { key:'select', label:'' },
            { key:'name', label:'世界名', sortable:true },
            { key:'lastUpdate', label:'最終更新日', sortable:true },
            { key:'nextUpdate', label:'次回更新日', sortable:true }
          ]"
          :perPage="20"
          :selectable="true"
          tableKey='RID'
        >
          <template v-slot:cell(select)="row">
            <b-form-radio name="action"
              v-model="form.world"
              :value="row.item.RID"
              class="area"
            >
            </b-form-radio>
          </template>
          <template v-slot:cell(name)="row">
            <router-link :to="'/world/'+row.item.RID">
              {{ row.item.name }}
            </router-link>
          </template>
          <template v-slot:cell(lastUpdate)="row">
            {{ lastUpdate(row) }}
          </template>
          <template v-slot:cell(nextUpdate)="row">
            {{ nextUpdate(row) }}
          </template>
        </select-list>
      </b-form-group>
      <b-form-group id="keyword" label="呪文"
        description="砂場をひらがなで">
        <b-form-input v-model="form.keyword" />
      </b-form-group>

      <b-button type="button" variant="primary" @click="onSubmit" disabled>登録</b-button>
      <b-alert variant="danger" show>現在登録できません。詳細はお知らせにて。まったりお待ちください。</b-alert>
      <response-message ref="response" :value="postMessage" />
    </b-form>
  </WhitePage>
</template>

<script>
import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import SelectList from '@/components/SelectList'
import ResponseMessage from '@/components/ResponseMessage'
import moment from 'moment/src/moment'
import _ from 'lodash'
export default {
  components: {
    WhitePage,
    TitleBar,
    ResponseMessage,
    SelectList
  },
  data () {
    return {
      form: {
        nickname: '',
        keyword: '',
        world: 'main',
        class: ''
      },
      world: [],
      max: 0,
      current: 0,
      postMessage: {},
      loading: false
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
      this.world = response.world
      this.max = response.max
      this.current = response.current
    },
    onSubmit () {
      this.$store.dispatch('entrySubCharacter', this.form)
        .then((response) => {
          this.postMessage = response
          if(response.error === '200 OK'){
            this.$store.commit('LOGIN')
            this.$router.push({ path:'/change/'+_.findIndex(response.accounts, { eno:response.eno }) })
          }
        })
    },
    lastUpdate: (row)=> moment(new Date(row.item.lastUpdate*1000)).format('YYYY/MM/DD'),
    nextUpdate: (row)=> moment(new Date(row.item.nextUpdate*1000)).format('YYYY/MM/DD'),
  },
  beforeRouteEnter (route, redirect, next) {
    store.dispatch('getSubCharacter')
      .then((response) => {
        next(vm => vm.checkService(response))        
      })
  },
}
</script>

<style lang="scss" scoped>
.init-class {
  border: 2px solid #CCC;

  td {
    border: 1px solid #CCC;
    height: 100px;
  }
}
</style>
